// extracted by mini-css-extract-plugin
module.exports = {"projectCard":"style_projectCard__gDFEMEYlIVBECxmBSwIEp"};